import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Nav, Footer } from "./Nav";
import { api } from "../api";

export function PaymentReturn({ cancelled }) {
  const navigate = useNavigate();
  const [state, setState] = useState(cancelled ? "cancelled" : "checking");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (cancelled) return;
    const params = new URLSearchParams(window.location.search);
    const sid = params.get("session_id");
    if (!sid) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setInfo(data); setState("paid"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setState("error"); return; }
      } catch {}
      if (tries++ < 8) setTimeout(poll, 2000);
      else setState("pending");
    };
    poll();
  }, [cancelled]);

  return (
    <>
      <Nav />
      <section className="hero" style={{ minHeight: "60vh", background: "linear-gradient(180deg,#1c1a17,#141414)" }}>
        <div className="wrap hero-inner" style={{ textAlign: "center" }} data-testid="payment-return">
          {state === "checking" && (<>
            <Loader2 size={44} className="spin" style={{ color: "#C7921E" }} />
            <h1 style={{ marginTop: "1rem" }}>Confirming your enrolment…</h1>
            <p className="lead">One moment while we check your payment with Stripe.</p>
          </>)}
          {state === "paid" && (<>
            <CheckCircle2 size={48} style={{ color: "#3fce7a" }} />
            <h1 style={{ marginTop: "1rem" }}>You're in. Welcome aboard.</h1>
            <p className="lead" data-testid="payment-success-msg">
              Your enrolment on <strong>{info?.title}</strong> is confirmed
              {info?.plan === "installment" ? " on the 6-month plan" : " — and your Passing Guarantee is active"}.
            </p>
            <div className="actions" style={{ justifyContent: "center" }}>
              <button className="btn btn-primary" onClick={() => navigate(`/study/${info?.item_id}`)}>
                Enter your study room
              </button>
              <Link className="btn btn-gold-outline" to="/hub">Go to My Hub</Link>
            </div>
          </>)}
          {state === "pending" && (<>
            <Loader2 size={44} style={{ color: "#C7921E" }} />
            <h1 style={{ marginTop: "1rem" }}>Almost there…</h1>
            <p className="lead">Your payment is processing. Your access will unlock shortly — check My Hub in a minute.</p>
            <Link className="btn btn-primary" to="/hub">Go to My Hub</Link>
          </>)}
          {state === "cancelled" && (<>
            <XCircle size={44} style={{ color: "#b9ad9c" }} />
            <h1 style={{ marginTop: "1rem" }}>No payment was taken.</h1>
            <p className="lead">Your place is still open whenever you're ready.</p>
            <Link className="btn btn-primary" to="/nlp/nlp_practitioner">Back to the courses</Link>
          </>)}
          {state === "error" && (<>
            <XCircle size={44} style={{ color: "#b0392b" }} />
            <h1 style={{ marginTop: "1rem" }}>We couldn't confirm that.</h1>
            <p className="lead">If you were charged, don't worry — contact us and we'll sort it right away.</p>
            <Link className="btn btn-primary" to="/hub">Go to My Hub</Link>
          </>)}
        </div>
      </section>
      <Footer />
    </>
  );
}
